import styled from 'styled-components';

export default styled.em`
  font-weight: 700;
  font-style: normal;
`;
